"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var convert_currency_1 = require("../convert_currency");
var money_1 = require("../money");
var offer_operations_1 = require("./offer_operations");
var offer_calculator_1 = require("./offer_calculator");
var offer_create_form_fields_1 = require("./offer_create_form_fields");
var location_form_1 = require("./location_form");
var bind_1 = require("../bind");
var tracker_1 = require("../tracker");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var rql_1 = require("../rql");
var user_context_provider_1 = require("../components/user_context_provider");
var lodash_1 = require("lodash");
var defaultState = function () {
    return {
        error: '',
        isFormSaving: false,
        offer: {
            price: '',
            message: '',
            quantity: 1,
        },
        location: { postalCode: '', shippingRegionCode: '' },
        isEditingLocation: true,
    };
};
var COMPONENT_NAME = 'OfferCreateForm';
var OfferCreateForm = /** @class */ (function (_super) {
    tslib_1.__extends(OfferCreateForm, _super);
    function OfferCreateForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = defaultState();
        return _this;
    }
    OfferCreateForm.prototype.componentDidMount = function () {
        this.setInitialLocation({});
    };
    OfferCreateForm.prototype.componentDidUpdate = function (prevProps) {
        if (lodash_1.isEmpty(lodash_1.get(prevProps, 'data.listing')) && !lodash_1.isEmpty(lodash_1.get(this.props, 'data.listing'))) {
            this.trackView();
        }
        this.setInitialLocation(prevProps);
    };
    OfferCreateForm.prototype.missingRequiredLocation = function (address) {
        if (this.props.isSeller) {
            return false;
        }
        return !(address && address.postalCode && address.shippingRegionCode);
    };
    OfferCreateForm.prototype.setInitialLocation = function (prevProps) {
        var shippingInfo = lodash_1.get(this.props, 'data.listing.shipping');
        var prevShippingInfo = lodash_1.get(prevProps, 'data.listing.shipping');
        if (!prevShippingInfo && shippingInfo) {
            var location_1 = {
                postalCode: lodash_1.get(shippingInfo, 'shippingAddress.postalCode', ''),
                shippingRegionCode: shippingInfo.shippingRegionCode,
            };
            this.setState({
                location: location_1,
                isEditingLocation: this.missingRequiredLocation(location_1),
            });
        }
    };
    Object.defineProperty(OfferCreateForm.prototype, "trackingContext", {
        get: function () {
            return {
                locationPrefilled: !this.state.isEditingLocation,
                shopCurrency: this.shopCurrency,
                userCurrency: this.props.user.currency,
                channel: this.props.shopChannel,
            };
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateForm.prototype.trackView = function () {
        tracker_1.trackView({
            componentName: COMPONENT_NAME,
            ids: [this.props.listingId],
            type: tracker_1.LISTING_TYPE,
            context: this.trackingContext,
        });
    };
    Object.defineProperty(OfferCreateForm.prototype, "isLoading", {
        get: function () {
            return lodash_1.get(this.props, 'data.loading');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "isInitializing", {
        get: function () {
            return !lodash_1.get(this.props, 'data.listing');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "shopCurrency", {
        get: function () {
            return this.props.data.listing.shop.currency;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "errorLoading", {
        get: function () {
            if (this.isInitializing) {
                return false;
            }
            return lodash_1.get(this.props, 'data.error') ||
                (!this.props.data.exchangeRates && (this.props.user.currency !== this.shopCurrency));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "exchangeRates", {
        get: function () {
            return lodash_1.get(this.props, 'data.exchangeRates.rates', []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "offerError", {
        get: function () {
            return lodash_1.get(this.props, 'data.error.message');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "shippingPrice", {
        get: function () {
            if (this.props.isSeller && !lodash_1.isNil(this.offerState.shippingPrice)) {
                return this.offerState.shippingPrice;
            }
            var amount = lodash_1.get(this.props, 'data.listing.shipping.shippingPrices[0].rate.amount');
            return money_1.formatNumber(amount);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "quantity", {
        get: function () {
            if (this.props.isSeller && !lodash_1.isNil(this.offerState.quantity)) {
                return this.offerState.quantity;
            }
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "offerState", {
        get: function () {
            return tslib_1.__assign(tslib_1.__assign({}, this.state.offer), this.props.offer);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "offer", {
        get: function () {
            return tslib_1.__assign(tslib_1.__assign({}, this.offerState), { shippingPrice: this.shippingPrice, quantity: this.quantity });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "buyerHasAtLeastOneAcceptedOffer", {
        get: function () {
            return lodash_1.get(this.props.data, 'me.offerCount.total') > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateForm.prototype, "disableSaveButton", {
        get: function () {
            return this.isLoading ||
                this.state.isFormSaving ||
                !this.offer.price ||
                this.missingRequiredLocation(this.state.location);
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateForm.prototype.createNegotiation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var shopCurrencyOfferPrice, offerItem, shippingRegionCodeForBuyer, input, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shopCurrencyOfferPrice = convert_currency_1.convertCurrency(this.offerCurrency, this.props.data.listing.shop.currency, this.exchangeRates, this.offer.price);
                        offerItem = {
                            listingId: this.props.listingId,
                            quantity: this.quantity,
                            price: shopCurrencyOfferPrice,
                        };
                        if (this.props.isSeller) {
                            offerItem['shippingPrice'] = money_1.parseAmount(this.shippingPrice, this.props.data.listing.shop.currency);
                        }
                        shippingRegionCodeForBuyer = null;
                        if (!this.props.isSeller) {
                            shippingRegionCodeForBuyer = this.state.location.shippingRegionCode;
                        }
                        input = tslib_1.__assign({ recipientUuid: this.props.recipientUuid, message: this.offer.message, offerItems: [offerItem], shippingRegionCode: shippingRegionCodeForBuyer, postalCode: this.state.location.postalCode }, (this.props.additionalMutationParams || {}));
                        return [4 /*yield*/, this.props.createInitialOffer({ variables: { input: input } })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, lodash_1.get(result, 'data.createNegotiation.negotiations.0')];
                }
            });
        });
    };
    OfferCreateForm.prototype.handleOpenLocationForm = function () {
        this.setState({ isEditingLocation: true });
    };
    OfferCreateForm.prototype.calculateDiscountPercent = function () {
        return Math.round((1 - (parseFloat(this.offer.price) / parseFloat(this.props.data.listing.price.amount))) * 100);
    };
    OfferCreateForm.prototype.handleSubmit = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, errors_1, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.setState({ isFormSaving: true, error: null });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.createNegotiation()];
                    case 2:
                        response = _a.sent();
                        tracker_1.trackInteraction({
                            componentName: COMPONENT_NAME,
                            entityId: this.props.listingId,
                            type: tracker_1.LISTING_TYPE,
                            interactionType: tracker_1.SUBMIT,
                            context: tslib_1.__assign(tslib_1.__assign({}, this.trackingContext), { negotiationId: response.id }),
                            mParticleInteraction: {
                                eventName: mparticle_tracker_1.MParticleEventName.SubmittedOffer,
                                listingId: this.props.listingId,
                                discountPercent: this.calculateDiscountPercent(),
                            },
                        });
                        this.setState({ isFormSaving: false });
                        this.props.onSuccess(response);
                        return [3 /*break*/, 4];
                    case 3:
                        errors_1 = _a.sent();
                        message = lodash_1.first(lodash_1.get(errors_1, 'graphQLErrors', [{ message: '' }])).message;
                        this.setState({ error: message, isFormSaving: false });
                        this.props.onError && this.props.onError(errors_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OfferCreateForm.prototype, "isControlledComponent", {
        get: function () {
            return !!this.props.offer;
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateForm.prototype.handleOfferChange = function (offer) {
        if (this.isControlledComponent) {
            this.props.onChange(offer);
        }
        else {
            this.setState({
                offer: tslib_1.__assign(tslib_1.__assign({}, this.state.offer), offer),
            });
        }
    };
    OfferCreateForm.prototype.refetchOnShippingRegionCodeChange = function (previousShippingRegionCode) {
        var shippingRegionCode = this.state.location.shippingRegionCode;
        if (shippingRegionCode !== previousShippingRegionCode) {
            this.props.data.refetch({ shippingRegionCode: shippingRegionCode, usePrimaryShippingAddress: false });
        }
    };
    OfferCreateForm.prototype.handleLocationChange = function (location) {
        var _this = this;
        var previousShippingRegionCode = this.state.location.shippingRegionCode;
        this.setState({
            location: tslib_1.__assign(tslib_1.__assign({}, this.state.location), location),
        }, function () { return _this.refetchOnShippingRegionCodeChange(previousShippingRegionCode); });
    };
    OfferCreateForm.prototype.renderListingPrice = function () {
        return (React.createElement("div", { className: "offers-form__original-price" }, I18n.t('commons.offers.originalPrice', { price: this.props.data.listing.price.display })));
    };
    OfferCreateForm.prototype.renderLocation = function () {
        if (this.isInitializing || this.props.isSeller) {
            return null;
        }
        return (React.createElement("div", { className: "mtb-1 bdt-1 bdb-1 bd--offwhite scaling-ptb-2" },
            React.createElement(location_form_1.default, { isEditing: this.state.isEditingLocation, countries: lodash_1.get(this.props.data, 'countries.countries', []), location: this.state.location, onLocationChange: this.handleLocationChange, onEditLocation: this.handleOpenLocationForm }),
            this.renderLocationMessage()));
    };
    OfferCreateForm.prototype.renderLocationMessage = function () {
        var _a = this.props.data.listing, shipping = _a.shipping, shop = _a.shop;
        if (this.props.data.loading) {
            return null;
        }
        if (shipping.localPickupOnly) {
            return (React.createElement("div", { className: "alert-box alert-box--small mobile-size-90 mt-1" }, I18n.t('commons.offers.location.localPickupDetails', { location: shop.address.displayLocation })));
        }
        if (shipping.shippingPrices.length === 0 && !shipping.localPickupOnly) {
            return (React.createElement("div", { className: "alert-box alert-box--blue alert-box--small mobile-size-90 mt-1" }, I18n.t('commons.offers.location.noShippingCostSet')));
        }
        return null;
    };
    Object.defineProperty(OfferCreateForm.prototype, "offerCurrency", {
        get: function () {
            return this.props.isSeller ?
                this.props.data.listing.shop.currency :
                this.props.user.currency;
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateForm.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.props.onCancel();
    };
    Object.defineProperty(OfferCreateForm.prototype, "submitButtonText", {
        get: function () {
            if (!lodash_1.isEmpty(this.offer.price)) {
                return I18n.t('commons.offers.submitOfferButtonWithAmount', {
                    offerTotal: offer_calculator_1.offerTotal(this.offer, this.offerCurrency).display,
                });
            }
            return I18n.t('commons.offers.submitOfferButton');
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateForm.prototype.renderButtons = function () {
        return (React.createElement("div", { className: "offers-form__actions" },
            React.createElement("button", { className: "offers-form__actions__save", type: "submit", disabled: this.disableSaveButton }, this.submitButtonText),
            this.props.onCancel &&
                React.createElement("button", { className: "offers-form__actions__back", onClick: this.handleCancel }, I18n.t('commons.offers.backAction'))));
    };
    OfferCreateForm.prototype.render = function () {
        if (this.errorLoading) {
            return (React.createElement("div", { className: "alert-box alert-box--red" },
                React.createElement("p", { className: "mb-0" }, I18n.t('commons.offers.error'))));
        }
        if (this.isInitializing) {
            return (React.createElement("div", { className: "offers-form offers-form--loading" },
                React.createElement("div", { className: "offers-form-placeholder" }),
                React.createElement("div", { className: "offers-form-placeholder" }),
                React.createElement("div", { className: "offers-form-placeholder" })));
        }
        return (React.createElement("form", { className: "offers-form", onSubmit: this.handleSubmit },
            React.createElement("div", { className: "offers-form__header" },
                this.renderListingPrice(),
                this.renderLocation()),
            React.createElement(offer_create_form_fields_1.default, { error: this.state.error, listing: this.props.data.listing, exchangeRates: this.exchangeRates, currency: this.offerCurrency, offer: this.offer, onOfferChange: this.handleOfferChange, initialAgreementChecked: this.buyerHasAtLeastOneAcceptedOffer, party: this.props.isSeller ? rql_1.core_apimessages_NegotiationParty.SELLER : rql_1.core_apimessages_NegotiationParty.BUYER, 
                // if we show editable location form, offer amount is no longer the first input, and we will instead autofocus
                // the shipping region selector (see components/offers/shipping_region_selector.tsx)
                autoFocus: !this.state.isEditingLocation, notices: this.props.notices, messageInput: this.props.messageInput, showNewOfferNudge: this.props.showNewOfferNudge }),
            this.renderButtons()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateForm.prototype, "createNegotiation", null);
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateForm.prototype, "handleOpenLocationForm", null);
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateForm.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateForm.prototype, "handleOfferChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateForm.prototype, "handleLocationChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateForm.prototype, "handleCancel", null);
    return OfferCreateForm;
}(React.Component));
exports.OfferCreateForm = OfferCreateForm;
var connectCreateOfferForm = react_apollo_1.compose(offer_operations_1.connectCreateOfferFormQuery, offer_operations_1.connectCreateInitialOfferMutation)(OfferCreateForm);
exports.default = user_context_provider_1.withUserContext(connectCreateOfferForm);
//# sourceMappingURL=offer_create_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_create_form.js
// module id = lUwU
// module chunks = 20 21